import $ from 'jquery';

export default class Split {
  constructor(element) {
    this.$element = $(element);
    this.format();
  }

  format() {
    const title = this.$element.html();
    const regex = /(.+)(<br>\s?)(.+)/gi;
    const heading = title.replace(regex, '$1 <span>$3</span>');
    this.$element.html(heading);
  }
}



// WEBPACK FOOTER //
// ./Split.js